<template>
  <v-dialog v-model="dialog" persistent width="800" height="500">
    <v-card>
      <v-card-title
        >Browse Plans
        <v-spacer />
        <v-btn icon color="red" @click="close" tile>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-card outlined tile>
          <v-data-table :headers="headers" :items="planlist">
            <template v-slot:item.action="{ item }">
              <v-btn
                v-if="item.rs"
                @click="select(item.rs)"
                block
                style="margin: 0px"
                small
                depressed
                color="primary"
                >{{ item.rs }}</v-btn
              >
            </template>
          </v-data-table>
        </v-card>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      dialog: false,
      planlist: [],
      headers: [
        {
          text: "Rs",
          value: "rs",
          align: "left",
          sortable: false,
          divider: true,
        },
        { text: "Description", value: "desc", divider: true },
        { text: "Action", value: "action" },
      ],
    };
  },
  methods: {
    select(rs) {
      let vm = this;
      vm.dialog = false;
      vm.planlist = [];
      vm.$parent.form.amount = rs;
    },
    close() {
      let vm = this;
      vm.dialog = false;
      vm.planlist = [];
    },
    async init() {
      const vm = this;
      let { provider, phone } = vm.$parent.form;
      if (!phone) {
        vm.$alert.show("Please enter the phone number");
        return;
      }
      let isProvider =
        provider instanceof Object == false || provider.Mplan_Code == undefined;
      if (isProvider) {
        vm.$alert.show("Please select the provider");
        return;
      }
      let operator = provider.Mplan_Code;
      try {
        vm.$loader.show();
        let data = await vm.$store.dispatch("fetchBill", {
          offer: "roffer",
          tel: phone,
          type: "prepaid",
          operator,
        });
        if (data.status == "1") {
          let { records } = data;
          vm.planlist = records;
          console.log(vm.planlist);
          vm.dialog = true;
        } else {
          vm.$alert.show("Plan info not available");
        }
        vm.$loader.hide();
      } catch (error) {
        console.log(error);
        vm.$loader.hide();
        vm.$alert.show(error.message);
      }
    },
  },
  mounted() {
    let vm = this;
    vm.dialog = false;
    vm.dialog = vm.model;
    vm.planlist = vm.pplans;
  },
};
</script>
